import { render, staticRenderFns } from "./newList.vue?vue&type=template&id=554c8a48&scoped=true"
import script from "./newList.vue?vue&type=script&lang=js"
export * from "./newList.vue?vue&type=script&lang=js"
import style0 from "./newList.vue?vue&type=style&index=0&id=554c8a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554c8a48",
  null
  
)

export default component.exports